/* eslint-disable @typescript-eslint/no-explicit-any */
import { HierarchyNode, stratify, tree } from "d3-hierarchy";
import { Node } from "reactflow";

const createMutipleTrees = (root: HierarchyNode<unknown>): HierarchyNode<unknown>[] => {
    const descendants = root.descendants();

    const roots = descendants.reduce(
        (rootArr: any[], descendant: any) => {
            if (descendant?.data?.data?.isFinalAction) {
                return rootArr.concat(descendant);
            }

            return rootArr;
        },
        [root]
    );

    return roots;
};

const createGraphLayout = (nodes: Node[]) => {
    if (nodes.length > 0) {
        const root: HierarchyNode<unknown> = stratify()
            .id((d: any) => d.id)
            .parentId((d: any) => d.data.parentId)(nodes);
        const roots: HierarchyNode<unknown>[] = createMutipleTrees(root);

        // Compute the layout.
        const dx = 350;
        const dy = 200;

        let numberOfFinalAction = 0;
        let currentRoot = roots?.[0];
        tree().nodeSize([dx, dy])(currentRoot);
        return nodes.map((node) => {
            const treeNode: any = currentRoot.descendants().find((descendant: any) => descendant.id == node.id);
            const isFinalAction = treeNode?.data?.data?.isFinalAction ?? false;

            if (isFinalAction) {
                numberOfFinalAction = numberOfFinalAction + 1;
                currentRoot = roots?.[numberOfFinalAction];
                tree().nodeSize([dx, dy])(currentRoot);
            }

            const positionX = Number(treeNode?.x ?? 0);
            const positionY = Number(treeNode?.y ?? 0);

            return {
                ...node,
                position: {
                    x: positionX,
                    y: positionY,
                },
            };
        });
    }

    return nodes;
};

export default createGraphLayout;
